export default __webpack_public_path__ + "static/media/Rnovios.e863bf7b.svg";